export default __webpack_public_path__ + "static/media/shopping.667f9f5a.svg";